import * as React from 'react';

export default function FAQLight(props) {
  const { width = 150, height = 150, primary } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 3508"
            fill="#fff"
            stroke="#707070"
            d="M0 0h35v35H0z"
          />
        </clipPath>
        <clipPath id="b">
          <path data-name="Rectangle 3509" d="M0 0h35v35H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <g clipPath="url(#b)" data-name="Mask Group 1662">
          <g data-name="Path 62326">
            <path
              data-name="Path 63098"
              d="M24.76 5.113a12.693 12.693 0 0 1 4.95 17.254c-2.875 5.187-8.014 7.806-13.542 6.349-.953-.252-4.98 3.111-5.924 2.588-1.137-.63-.196-5.547-1.088-6.475A12.425 12.425 0 0 1 7.51 10.062 12.693 12.693 0 0 1 24.76 5.113Z"
              fill="none"
            />
            <path
              data-name="Path 63099"
              d="M24.082 6.338a11.305 11.305 0 0 0-15.351 4.401 11.065 11.065 0 0 0 1.432 13.123c.803.835.814 2.245.838 4.035.006.518.015 1.266.067 1.814.52-.263 1.201-.671 1.672-.953 1.819-1.091 2.813-1.65 3.782-1.393 4.743 1.251 9.326-.923 11.959-5.673a11.305 11.305 0 0 0-4.399-15.354m.679-1.225a12.693 12.693 0 0 1 4.948 17.254c-2.875 5.188-8.013 7.806-13.54 6.349-.954-.252-4.98 3.111-5.925 2.588-1.137-.63-.196-5.547-1.088-6.475A12.426 12.426 0 0 1 7.51 10.062 12.693 12.693 0 0 1 24.76 5.113Z"
              fill="#fff"
            />
          </g>
          <path
            data-name="Path 62586"
            d="M14.026 13.607h2.524a1.817 1.817 0 0 1 .542-1.262 1.8 1.8 0 0 1 1.3-.47 2.057 2.057 0 0 1 .931.2 1.53 1.53 0 0 1 .619.54 1.422 1.422 0 0 1 .219.788 1.962 1.962 0 0 1-.14.768 1.763 1.763 0 0 1-.48.629 6.671 6.671 0 0 1-.945.661 4.485 4.485 0 0 0-1.029.8 2.362 2.362 0 0 0-.55.973 3.7 3.7 0 0 0-.1 1.279l.019.54h2.463v-.494a2.05 2.05 0 0 1 .14-.792 1.77 1.77 0 0 1 .485-.637 6.069 6.069 0 0 1 .959-.657 4.411 4.411 0 0 0 1.49-1.336 3.221 3.221 0 0 0 .5-1.822 3.258 3.258 0 0 0-.554-1.877 3.676 3.676 0 0 0-1.546-1.27 5.513 5.513 0 0 0-2.324-.456 5.431 5.431 0 0 0-2.431.5 3.627 3.627 0 0 0-1.537 1.374 4.015 4.015 0 0 0-.559 2.021Zm4.238 9.938a1.744 1.744 0 0 0 1.234-.42 1.475 1.475 0 0 0 .452-1.135 1.483 1.483 0 0 0-.452-1.15 1.756 1.756 0 0 0-1.234-.414 1.773 1.773 0 0 0-1.239.414 1.475 1.475 0 0 0-.456 1.15 1.467 1.467 0 0 0 .457 1.136 1.761 1.761 0 0 0 1.239.419Z"
            fill="#fff"
          />
          <path
            d="M14.026 13.607h2.524a1.817 1.817 0 0 1 .542-1.262 1.8 1.8 0 0 1 1.3-.47 2.057 2.057 0 0 1 .931.2 1.53 1.53 0 0 1 .619.54 1.422 1.422 0 0 1 .219.788 1.962 1.962 0 0 1-.14.768 1.763 1.763 0 0 1-.48.629 6.671 6.671 0 0 1-.945.661 4.485 4.485 0 0 0-1.029.8 2.362 2.362 0 0 0-.55.973 3.7 3.7 0 0 0-.1 1.279l.019.54h2.463v-.494a2.05 2.05 0 0 1 .14-.792 1.77 1.77 0 0 1 .485-.637 6.069 6.069 0 0 1 .959-.657 4.411 4.411 0 0 0 1.49-1.336 3.221 3.221 0 0 0 .5-1.822 3.258 3.258 0 0 0-.554-1.877 3.676 3.676 0 0 0-1.546-1.27 5.513 5.513 0 0 0-2.324-.456 5.431 5.431 0 0 0-2.431.5 3.627 3.627 0 0 0-1.537 1.374 4.015 4.015 0 0 0-.559 2.021Zm4.238 9.938a1.744 1.744 0 0 0 1.234-.42 1.475 1.475 0 0 0 .452-1.135 1.483 1.483 0 0 0-.452-1.15 1.756 1.756 0 0 0-1.234-.414 1.773 1.773 0 0 0-1.239.414 1.475 1.475 0 0 0-.456 1.15 1.467 1.467 0 0 0 .457 1.136 1.761 1.761 0 0 0 1.239.419Z"
            fill={primary}
            opacity={0.35}
          />
        </g>
      </g>
    </svg>
  );
}
